import * as types from './actionTypes'

export const calculateWithdrawAction = input => ({
  type: types.CALCULATE_WITHDRAW,
  payload: { amount: input },
})

export const makeWithdrawAction = payload => ({
  type: types.MAKE_WITHDRAW,
  payload,
})

export const resetWithdrawToListAction = resetWithdrawResponseData => ({
  type: types.RESET_WITHDRAW_SUCCEEDED,
  payload: {
    ...resetWithdrawResponseData,
    type: 'withdraw',
    status: 'processing',
    _created: true,
    _animated: false,
  },
})
